<template>
  <div class="content">
    <!-- <div style="margin-bottom:39px;">
                <div class="create_form_item"  >
                    <span class="require">*</span>
                    <span class="title">旧密码</span>
                    <input 
                        v-model="oldpassword"
                        type="text"
                        placeholder=""
                    >
                </div>
        </div>  -->
    <div style="margin-bottom: 39px">
      <div class="create_form_item">
        <!-- <span class="require">*</span> -->
        <span class="title">新密码</span>
        <input v-model="changePwdstr" type="text" placeholder="" />
      </div>
    </div>
    <div style="margin-bottom: 39px">
      <div class="create_form_item">
        <!-- <span class="require">*</span> -->
        <span class="title">确认密码</span>
        <input v-model="changePwdstr1" type="text" placeholder="" />
      </div>
    </div>
    <div>
      <button class="btn_class" @click="edit">确认修改</button>
    </div>
  </div>
</template>
<script>
import { admin } from "@/api/admin";
import { initPassword } from "../api/BusinessManagement.js";
export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
  data() {
    return {
      btnclick: true,
      oldpassword: "",
      changePwdstr: "",
      changePwdstr1: "",
      userInfor: {},
    };
  },
  mounted() {
    // this.getinfor();
  },
  methods: {
    getinfor() {
      admin.getaccountInfor("").then((res) => {
        if (res.data.success == true) {
          this.userInfor = res.data.result;
        }
      });
    },
    edit() {
      // if(!this.btnclick){
      //     this.$Message.error('已提交，请稍候');
      //     return;
      // }
      // if(this.newpassword.length<=8){
      //     this.$Message.error('新密码应为8位以上并包含数字、小写字母、大写字母、符号任意三种');
      //     return;
      // }
      // let a=0;
      // if((/[A-Z]/).test(this.newpassword))
      // {
      //     a++;
      // }
      // if((/[a-z]/).test(this.newpassword))
      // {
      //     a++;
      // }
      // if((/[0-9]/).test(this.newpassword))
      // {
      //     a++;
      // }
      // if((/[~#^$@%&!?%*,.<>"':;()]/).test(this.newpassword))
      // {
      //     a++;
      // }
      // if(a<3){
      //    this.$Message.error('新密码应为8位以上并包含数字、小写字母、大写字母、符号任意三种');
      //     return;
      // }
      // if(this.newpassword!==this.confirmpassword){
      //     this.$Message.error('新密码与确认密码不相符');
      //     return;
      // }
      // this.btnclick=false;
      // admin.changepassword(this.userInfor.userId,this.newpassword,this.oldpassword).then(res=>{
      //     this.btnclick=true;
      //     if(res.data.success==true){
      //         sessionStorage.removeItem('user');
      //         this.$router.go(-1);
      //     }else{
      //         this.$Message.error(res.data.message);
      //     }
      // })
      if (this.changePwdstr == "") {
        this.$message.error("请输入新密码");
      } else if (this.changePwdstr1 == "") {
        this.$message.error("请输入确认新密码");
      } else if (this.changePwdstr.length < 6) {
        this.$message.error("密码最少为六位");
      } else if (this.changePwdstr1.length < 6) {
        this.$message.error("密码最少为六位");
      } else if (this.changePwdstr !== this.changePwdstr1) {
        this.$message.error("新密码与确认新密码不一致");
      } else {
        initPassword({
          userId: sessionStorage.userId,
          password: this.changePwdstr,
        }).then((res) => {
          if (res.status === 200 && res.data.success) {
            this.$message.success(res.data.message);
            this.$router.go(-1);
          } else {
            this.$message.error(res.data.message);
          }
        });
      }
    },
  },
};
</script>
<style scoped>
.content {
  width: 700px;
  margin: 145px auto 60px;
  position: relative;
}
.create_form_item {
  margin-bottom: 30px;
}

.create_form_item .require {
  color: #ff1812;
  font-size: 14rpx;
}

.create_form_item .title {
  display: inline-block;
  color: #101d37;
  font-size: 14px;
  margin-left: 5px;
  width: 85px;
}

.create_form_item input {
  color: #101d37;
  font-size: 14px;
  width: 243px;
  height: 36px;
  border-radius: 4px;
  border: solid 1px #d9d9d9;
  padding-left: 20px;
}
::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #bfbfbf;
  font-size: 14px;
}

::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #bfbfbf;
  font-size: 14px;
}

:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #bfbfbf;
  font-size: 14px;
}
</style>

